export default __webpack_public_path__ + "static/media/Elder Wand - Img - Final (2)_02.4831fc9a.jpg";